export const AppUtilityFunctions = {
	getRedirectUrl() {
		let redirectUrl = window.location.origin + '/login';
		return redirectUrl;
	},
	calculateTimeDifferenceInSeconds(date1: any, date2: any) {
		const timeDifferenceInMilliseconds = date1 - date2;
		const timeDifferenceInSeconds = Math.floor(
			timeDifferenceInMilliseconds / 1000
		);
		return timeDifferenceInSeconds;
	},

	getCurrentDateTimeWithAddedMinutes(minutesToAdd: any) {
		const currentDateTime = new Date(); // Get the current date and time
		const newDateTime = new Date(
			currentDateTime.getTime() + minutesToAdd * 60 * 1000
		); // Add minutes
		return newDateTime;
	},
	parseDateStringToDate(dateString: any) {
		// Parse the date string into a Date object
		return new Date(dateString);
	},
	truncateText(text: any, maxLength: any) {
		if (typeof text !== 'string' || typeof maxLength !== 'number') {
			return '';
		}
		if (text.length > maxLength) {
			return text.substring(0, maxLength) + '...';
		}
		return text;
	},
	handleCopy(e: React.MouseEvent, text) {
		e.stopPropagation();
		navigator.clipboard.writeText(text).then(() => {
			console.log('Copied to clipboard:', text);
		});
	},
	getNextEmailName(currentName: string): string {
		// Match any trailing number
		const match = currentName.match(/(.*?)(\d+)$/);

		if (match) {
			const prefix = match[1].replace(/[_-]+$/, ''); // clean trailing underscores/dashes
			const number = parseInt(match[2], 10);
			return `${prefix}_${number + 1}`;
		}

		// If no number exists, start from 1
		return `${currentName}_1`;
	},
	isFreemiumUser() {
		const demoData = localStorage.getItem('userData');
		if (!demoData) return false;

		try {
			const { ['access-token']: token } = JSON.parse(demoData);
			if (!token) {
				console.warn('Access token not found');
				return false;
			}

			const [header, payload, signature] = token.split('.');
			if (!payload) {
				console.warn('Invalid access token format');
				return false;
			}

			const decodedPayload = JSON.parse(atob(payload));
			// Return true only if is_freemium is strictly true or string 'true'
			return decodedPayload?.is_freemium ?? true;
		} catch (error) {
			console.error('Error parsing userData or decoding token:', error);
			return false;
		}
	},
	convertToLocalTime(utcDate) {
	const date = new Date(utcDate + ' UTC');

	const day = date.getDate();
	const month = date.toLocaleString('en-US', { month: 'short' });
	const year = date.getFullYear();

	let hours = date.getHours();
	const minutes = String(date.getMinutes()).padStart(2, '0');

	const ampm = hours >= 12 ? 'PM ' : 'AM';
	hours = hours % 12 || 12;

	return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
}
};
